import React from 'react'
import { useIntl } from 'react-intl'

import { size } from 'lodash-es'

import { getFriendlyDate } from '@lyrahealth-inc/shared-app-logic/src/features/common/utils/dateUtils'
import { getProgramDisplayLabel } from '@lyrahealth-inc/shared-app-logic/src/features/programConfigs/programHelpers'
import { Capacity, ProviderUser } from '@lyrahealth-inc/shared-app-logic/src/models/user/User'
import DefaultButton from '@lyrahealth-inc/ui-core/lib/atoms/buttons/defaultButton/DefaultButton'
import CardFullWidth from '@lyrahealth-inc/ui-core/lib/molecules/layouts/cardFullWidth/CardFullWidth'

import styles from './availabilityCard.module.scss'
import { getProgramIcon } from '../../constants/programIconMap'

const CapacitiesFull: React.FC<CapacitiesFullProps> = ({
  provider,
  selectedProvider,
  currentAvailabilityStatusText,
  handleUpdateClick,
  shouldRequestAvailability,
  isCapacityProvider,
}) => {
  const intl = useIntl()
  const renderCapacities = (capacities: Capacity) => {
    return Object.entries(capacities).map(([programName]) => {
      const ProgramIcon = getProgramIcon(programName)
      return (
        <div className={styles['capacity-card']} key={programName}>
          {size(provider.capacity_value) > 1 && (
            <div className={styles['icon-container']}>{ProgramIcon && <ProgramIcon width={50} />}</div>
          )}
          <div className={styles['session-info']}>
            <p data-test-id='AvailabilityCard-programCapacity'>
              {size(provider.capacity_value) > 1 && `${getProgramDisplayLabel(intl, programName)} - `}
              {currentAvailabilityStatusText(programName)}
            </p>
            {provider.capacity_updated_at && (
              <p className={styles['update-date']}>
                Last updated{' '}
                {getFriendlyDate({
                  date: provider.capacity_updated_at,
                  intl,
                  displayWeekdayForRecentDates: false,
                })}
              </p>
            )}
          </div>
        </div>
      )
    })
  }

  return (
    <>
      <div className={styles['header-container']}>
        <h3>{`${selectedProvider ? 'Provider' : ''} Availability`}</h3>
        {(!shouldRequestAvailability || isCapacityProvider) && (
          <DefaultButton
            data-test-id='AvailabilityButton-update'
            style={{ whiteSpace: 'normal' }}
            onClick={handleUpdateClick}
          >
            Update
          </DefaultButton>
        )}
      </div>
      <CardFullWidth className={styles['card-container']} style={{ padding: 0 }} roundCorners>
        {renderCapacities(provider.capacity_value)}
      </CardFullWidth>
    </>
  )
}

type CapacitiesFullProps = {
  provider: ProviderUser
  selectedProvider: ProviderUser
  currentAvailabilityStatusText: (program_name: string) => React.ReactNode
  handleUpdateClick: () => void
  shouldRequestAvailability: boolean
  isCapacityProvider: boolean
}

export default CapacitiesFull
